import { useCallback, useEffect, useState } from 'react';
import { ComponentInputElementTypes } from '../../../editor/components/AttributeContainingTextInput/AttributeContainingTextInput';

export const useInputRef = (editMode: boolean) => {
  const [inputRef, setInputRef] = useState<
    HTMLInputElement | HTMLTextAreaElement
  >();
  const memoizedSetInputRef = useCallback(
    (ref: ComponentInputElementTypes) => {
      setInputRef(ref);
    },
    [setInputRef],
  );

  useEffect(() => {
    if (editMode && inputRef) {
      inputRef.focus();
    }
  }, [editMode, inputRef]);

  return { inputRef, memoizedSetInputRef };
};
